import React from 'react';
import { ApolloError } from 'apollo-client';
import { Query } from 'react-apollo';

import GET_COACH_STATUS_VALUES from 'coaching/queries/GetCoachStatusValues.gql';
import { GetCoachStatusValues } from 'coaching/queries/__generated__/GetCoachStatusValues';

export type Props = {
  children: (props: {
    statuses?: string[];
    loading: boolean;
    error?: ApolloError;
  }) => React.ReactNode;
};

export default function GetCoachStatusValuesContainer(props: Props) {
  return (
    <Query<GetCoachStatusValues> query={GET_COACH_STATUS_VALUES}>
      {({ loading, error, data }) => {
        return props.children({
          statuses: data?.coaching?.getCoachStatuses.statuses ?? [],
          loading,
          error,
        });
      }}
    </Query>
  );
}
